module.exports = __webpack_public_path__ + "static/img/whitetitle6.ed27b026.png";